// extracted by mini-css-extract-plugin
module.exports = {"root":"Breadcrumb_root__3gGC6","divider":"Breadcrumb_divider__1uLEG","link":"Breadcrumb_link__2k9ve"};